var _rect, _g, _mask, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.875,
    y: 25.875,
    width: 87.75,
    height: 87.75,
    rx: 23.625,
    fill: "url(#paint0_linear_6553_39889)",
    stroke: "url(#paint1_linear_6553_39889)",
    strokeWidth: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_6553_39889)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 88.5,
    height: 88.5,
    rx: 24,
    fill: "url(#paint2_linear_6553_39889)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.375,
    y: 6.375,
    width: 87.75,
    height: 87.75,
    rx: 23.625,
    stroke: "url(#paint3_linear_6553_39889)",
    strokeOpacity: 0.9,
    strokeWidth: 0.75
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_6553_39889",
    maskUnits: "userSpaceOnUse",
    x: 48.8164,
    y: 33.0781,
    width: 39,
    height: 39,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 48.8164,
    y: 33.0781,
    width: 39,
    height: 39
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2489 59.2491L58.217 69.2809C56.2953 71.2027 53.1795 71.2027 51.2577 69.2809C49.336 67.3592 49.336 64.2434 51.2577 62.3216L61.2896 52.2898L51.4785 42.4787C49.5567 40.557 49.5567 37.4412 51.4785 35.5194C53.4003 33.5977 56.516 33.5977 58.4378 35.5194L68.2489 45.3305L78.0599 35.5194C79.9817 33.5977 83.0975 33.5977 85.0192 35.5194C86.941 37.4412 86.941 40.557 85.0192 42.4787L75.2081 52.2898L85.24 62.3216C87.1617 64.2434 87.1617 67.3592 85.24 69.2809C83.3182 71.2027 80.2025 71.2027 78.2807 69.2809L68.2489 59.2491Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2489 59.2491L58.217 69.2809C56.2953 71.2027 53.1795 71.2027 51.2577 69.2809C49.336 67.3592 49.336 64.2434 51.2577 62.3216L61.2896 52.2898L51.4785 42.4787C49.5567 40.557 49.5567 37.4412 51.4785 35.5194C53.4003 33.5977 56.516 33.5977 58.4378 35.5194L68.2489 45.3305L78.0599 35.5194C79.9817 33.5977 83.0975 33.5977 85.0192 35.5194C86.941 37.4412 86.941 40.557 85.0192 42.4787L75.2081 52.2898L85.24 62.3216C87.1617 64.2434 87.1617 67.3592 85.24 69.2809C83.3182 71.2027 80.2025 71.2027 78.2807 69.2809L68.2489 59.2491Z",
    fill: "url(#paint4_linear_6553_39889)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.217 69.2809L57.6867 68.7506L58.217 69.2809ZM68.2489 59.2491L68.7792 58.7188C68.4863 58.4259 68.0114 58.4259 67.7185 58.7188L68.2489 59.2491ZM51.2577 69.2809L50.7274 69.8113H50.7274L51.2577 69.2809ZM51.2577 62.3216L51.7881 62.852L51.2577 62.3216ZM61.2896 52.2898L61.8199 52.8201C62.1128 52.5272 62.1128 52.0524 61.8199 51.7595L61.2896 52.2898ZM51.4785 42.4787L52.0088 41.9484H52.0088L51.4785 42.4787ZM51.4785 35.5194L50.9482 34.9891L51.4785 35.5194ZM58.4378 35.5194L57.9075 36.0498L58.4378 35.5194ZM68.2489 45.3305L67.7185 45.8608C67.8592 46.0015 68.0499 46.0805 68.2489 46.0805C68.4478 46.0805 68.6385 46.0015 68.7792 45.8608L68.2489 45.3305ZM78.0599 35.5194L77.5296 34.9891V34.9891L78.0599 35.5194ZM85.0192 35.5194L85.5495 34.9891L85.0192 35.5194ZM85.0192 42.4787L84.4889 41.9484V41.9484L85.0192 42.4787ZM75.2081 52.2898L74.6778 51.7595C74.3849 52.0524 74.3849 52.5272 74.6778 52.8201L75.2081 52.2898ZM85.24 69.2809L85.7703 69.8113V69.8113L85.24 69.2809ZM58.7473 69.8113L68.7792 59.7794L67.7185 58.7188L57.6867 68.7506L58.7473 69.8113ZM50.7274 69.8113C52.942 72.0259 56.5327 72.0259 58.7473 69.8113L57.6867 68.7506C56.0578 70.3795 53.4169 70.3795 51.7881 68.7506L50.7274 69.8113ZM50.7274 61.7913C48.5127 64.006 48.5127 67.5966 50.7274 69.8113L51.7881 68.7506C50.1592 67.1217 50.1592 64.4808 51.7881 62.852L50.7274 61.7913ZM60.7592 51.7595L50.7274 61.7913L51.7881 62.852L61.8199 52.8201L60.7592 51.7595ZM61.8199 51.7595L52.0088 41.9484L50.9482 43.0091L60.7592 52.8201L61.8199 51.7595ZM52.0088 41.9484C50.38 40.3195 50.38 37.6786 52.0088 36.0498L50.9482 34.9891C48.7335 37.2038 48.7335 40.7944 50.9482 43.0091L52.0088 41.9484ZM52.0088 36.0498C53.6377 34.4209 56.2786 34.4209 57.9075 36.0498L58.9681 34.9891C56.7535 32.7745 53.1628 32.7745 50.9482 34.9891L52.0088 36.0498ZM57.9075 36.0498L67.7185 45.8608L68.7792 44.8002L58.9681 34.9891L57.9075 36.0498ZM77.5296 34.9891L67.7185 44.8002L68.7792 45.8608L78.5903 36.0498L77.5296 34.9891ZM85.5495 34.9891C83.3349 32.7745 79.7442 32.7745 77.5296 34.9891L78.5903 36.0498C80.2191 34.4209 82.86 34.4209 84.4889 36.0498L85.5495 34.9891ZM85.5495 43.0091C87.7642 40.7944 87.7642 37.2038 85.5495 34.9891L84.4889 36.0498C86.1177 37.6786 86.1177 40.3195 84.4889 41.9484L85.5495 43.0091ZM75.7385 52.8201L85.5495 43.0091L84.4889 41.9484L74.6778 51.7595L75.7385 52.8201ZM74.6778 52.8201L84.7097 62.852L85.7703 61.7913L75.7385 51.7595L74.6778 52.8201ZM84.7097 62.852C86.3385 64.4808 86.3385 67.1217 84.7097 68.7506L85.7703 69.8113C87.985 67.5966 87.985 64.006 85.7703 61.7913L84.7097 62.852ZM84.7097 68.7506C83.0808 70.3795 80.4399 70.3795 78.811 68.7506L77.7504 69.8113C79.965 72.0259 83.5557 72.0259 85.7703 69.8113L84.7097 68.7506ZM78.811 68.7506L68.7792 58.7188L67.7185 59.7794L77.7504 69.8113L78.811 68.7506Z",
    fill: "url(#paint5_linear_6553_39889)",
    mask: "url(#path-4-outside-1_6553_39889)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_6553_39889",
    x: 15,
    y: -3,
    width: 106.5,
    height: 106.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6553_39889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6553_39889",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6553_39889",
    x1: 7.5,
    y1: 25.5,
    x2: 96,
    y2: 114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6553_39889",
    x1: 12,
    y1: 30.75,
    x2: 87.75,
    y2: 117.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1586A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6553_39889",
    x1: 24,
    y1: 6,
    x2: 112.5,
    y2: 94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE3E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6553_39889",
    x1: 28.5,
    y1: 11.25,
    x2: 104.25,
    y2: 98.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6553_39889",
    x1: 51.4782,
    y1: 35.5194,
    x2: 85.2397,
    y2: 69.2809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6F80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6553_39889",
    x1: 60.8692,
    y1: 11.2734,
    x2: 102.059,
    y2: 52.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.8c4570e94ef6279d7ef0fe31bb072c0d.svg";
export { ForwardRef as ReactComponent };